import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { residentApi } from "../lib/api";

const Ctx = createContext(null);
const KEY = "bsk_resident_token";

export const ResidentAuthProvider = ({ children }) => {
  const [resident, setResident] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      setReady(true);
      return;
    }
    residentApi
      .get("/resident/me")
      .then((r) => setResident(r.data))
      .catch(() => localStorage.removeItem(KEY))
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (phone, password) => {
    const r = await residentApi.post("/resident/login", { phone, password });
    localStorage.setItem(KEY, r.data.token);
    setResident(r.data.resident);
    return r.data.resident;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(KEY);
    setResident(null);
  }, []);

  return <Ctx.Provider value={{ resident, ready, login, logout }}>{children}</Ctx.Provider>;
};

export const useResident = () => useContext(Ctx);
